export const apiErrorMessage = (errorMessages: string[] | undefined | null) => {
  let message = null;
  if (errorMessages && errorMessages[0] && errorMessages[0].length > 0) {
    message = errorMessages[0];
  }
  return message;
};
